import { render, staticRenderFns } from "./ComparePatentList.vue?vue&type=template&id=410fb69f"
import script from "./ComparePatentList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComparePatentList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports